import { render, staticRenderFns } from "./POSView.vue?vue&type=template&id=37eb8eda&scoped=true"
import script from "./POSView.vue?vue&type=script&lang=js"
export * from "./POSView.vue?vue&type=script&lang=js"
import style0 from "./POSView.vue?vue&type=style&index=0&id=37eb8eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eb8eda",
  null
  
)

export default component.exports